export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS';
export const GET_CUSTOM_FIELDS_REQUEST = 'GET_CUSTOM_FIELDS_REQUEST';

export const getCustomFieldsRequest = (onComplete) => ({
  type: GET_CUSTOM_FIELDS_REQUEST,
  onComplete
});
